import script from "./ContactConversation.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactConversation.vue?vue&type=script&lang=ts&setup=true"

import "./ContactConversation.vue?vue&type=style&index=0&id=137bec5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137bec5e"]])

export default __exports__